import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
	Alert,
	Button,
	Card,
	CircularProgress,
	Container,
	FilledInput,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import { default as bg, default as bg1 } from '../../../assets/img/bg.jpg';
import logo from '../../../assets/img/logo/logo.png';
import LoginWrapper from '../../../components/wrapper/loginWrapper/LoginWrapper';
import {
	setDepartmentId,
	setDepartmentName,
	setFirstName,
	setFullName,
	setLoggedIn,
	setMainMenu,
	setPersonalId,
	setRoleId,
	setTenantId,
	setToken,
	setUserEmail,
	setUserProfileId,
	setUserId,
	setClientId,
	setUserDetails,
} from '../../../redux/slices/auth/activeAccount';
import { setEmptyErrorMsg } from '../../../redux/slices/errorHandling/errorHandling';
import { Flex, MarginHandler, MHeading, Grid } from '../../../styledComponents';
import { fonts } from '../../../utils';
import colors from '../../../utils/colors';
import { errorNotify, isValidEmail, successNotify } from '../../../utils/helper';
import { Box, ForgotPassword, Form } from './styledComponent';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import CustomUploadFile from '../../../components/input/UploadImage';
import Logo from "../../../assets/img/logo/agahi logo.png"
const { colorWhite, colorPrimary, colorSecondary } = colors;
const { primaryFont } = fonts;

const styles = {
	box: {
		background: 'rgba(255, 255, 255, 0.2)',
		// maxWidth: "20vw",
		height: "100vh",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		padding: "2em",
		margin: "auto",
	},

};

function Login() {
	const largeScreen = useMediaQuery('(min-width:800px)');
	const { errorMsg } = useSelector((state) => state.errorHandling);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const from = '/';

	const [email, setEmail] = useState('');
	const [pwd, setPwd] = useState('');
	const [errMsg, setErrMsg] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [disabledBtn, setDisabledBtn] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [formData, setFormData] = useState({
		email: '',
		firstname: '',
		display_name: '',
		lastname: '',
		number: '',
		client_name: '',
		vatNumber: '',
		website: '',
		address: '',
		city: '',
		state: '',
		zipCode: '',
		country: '',
		category_id: '',
		gender: '',
		logo: '',
		enabled: true
	});

	const [selectedFile, setSelectedFile] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const handleCloseModal = () => setOpenModal(false);

	const handleClickShowPassword = () => {
		setShowPassword((prevState) => !prevState);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	useEffect(() => {
		setErrMsg('');

		return () => dispatch(setEmptyErrorMsg());
	}, [email, pwd, dispatch]);
	// clientAuth: {
	// 	headers: {
	// 		'xt-api-key':
	// 			'704952ded8eba109c4f242c6796d1ba7d23f01eaa4ca9b6166c55506f497e828',
	// 	},
	// 	method: 'get',
	// 	path: '/authenticate',
	// },
	let userToken = localStorage.getItem('user_token');

	// let authSuccess = response => {
	// 	const token = response?.data?.data?.token;
	// 	localStorage.setItem('client_token', token);
	// 	CoreHttpHandler.request('core', 'clientSettings', {}, settingsSuccess, settingsFailure);

	// };
	// "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOiIxIiwiY2xpZW50VG9rZW5JZCI6Ijg1MzRjM2VkLTgzM2MtNDQ2Ni1hZWRiLTVhODY0YzE3MDdiOSIsInV1aWQiOiI5MTYyZDYyMC00NTVlLTQwMDYtOGUzOS1jYTZmYWUxMmMwNDAiLCJ0aW1lIjoxNzA4Nzk0MzQxNjM0LCJpYXQiOjE3MDg3OTQzNDF9.9e7Zhy4s8AY2eb72_g9kXaQs3AdZ1OzTk59u2BLJIcQ"
	let authFailure = error => { };
	let clientAuthentication = async () => {
		// await Api.post(endPoints?.auth?.authenticate, {}, {
		// 	headers: {
		// 		'xt-api-key': '704952ded8eba109c4f242c6796d1ba7d23f01eaa4ca9b6166c55506f497e828' // Add the token here for this specific request
		// 	}
		// })
		// .then((response) => {
		// 	console.log(response)
		// 	// dispatch(setTenantId(response?.data?.tenantId));

		// })
		// .catch((error) => {

		// });
		// CoreHttpHandler.request('core', 'clientAuth', {}, authSuccess, authFailure);
	};

	let checkUser = () => {
		if (userToken !== null) {
			// props.history.push(HOME_URL);
			// } else if (hit !== false) {
		} else {
			clientAuthentication();

		}
	};
	React.useEffect(() => {
		checkUser();
	}, []);


	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			setDisabledBtn(true);

			const data = {
				password: pwd,
			};

			if (isValidEmail(email)) {
				data.email = email;
			} else {
				data.username = email;
			}
			setIsLoading(true);
			await Api.post(endPoints?.auth?.login, data)
				.then((response) => {
					// set main menu
					// dispatch(setMainMenu(JSON.parse(response?.data?.menuJson)));
					// set main menu
					dispatch(setMainMenu(response?.data?.data?.acl));
					// set userAccount logged in true
					dispatch(setLoggedIn(true));
					// set userAccount auth token
					dispatch(setToken(response?.data?.data?.token));
					// set roleId
					// dispatch(setRoleId(response?.data?.roleId));
					// set userProfileId
					// dispatch(setUserProfileId(response?.data?.userProfileId));
					// set personalDetailId
					// dispatch(setPersonalId(response?.data?.personalDetailId));
					dispatch(setUserDetails(response?.data?.data?.user));
					dispatch(setUserId(response?.data?.data?.user?.id));
					dispatch(setClientId(response?.data?.data?.user?.client_id));
					// set email
					dispatch(setUserEmail(response?.data?.data?.user?.email));
					// set name
					dispatch(setFirstName(response?.data?.data?.user?.firstName));
					// set full name
					dispatch(setFullName(response?.data?.data?.user?.firstName));
					// empty states
					setEmail('');
					setPwd('');
					// navigate to home page if credentials are true
					// navigate(from, { replace: true });
					window.location.replace(from);

					setIsLoading(false);
					setDisabledBtn(false);
					successNotify("Logged In Successfully")

				})
				.catch((error) => {
					setIsLoading(false);
					if (error?.response?.status === 400) {
						errorNotify(error?.response?.data);
						setDisabledBtn(false);
					}
					setErrMsg(error?.response?.data?.message || errorMsg);
					setDisabledBtn(false);
				});
		} catch (err) {
			setIsLoading(false);
			setErrMsg('Login Failed');
			setDisabledBtn(false);
		}

	};
	// const handleOnboardingSubmit = async (e) => {
	// 	// e.preventDefault();
	// 	// try {

	// 	// 	await Api.post(endPoints?.onBoard?.onboarding, {
	// 	// 		...formData,
	// 	// 	}, {
	// 	// 		headers: {
	// 	// 			'xt-client-token': null
	// 	// 		}
	// 	// 	})
	// 	// 		.then((response) => {


	// 	// 		})
	// 	// 		.catch((error) => {
	// 	// 			if (error?.response?.status === 400) {
	// 	// 				errorNotify(error?.response?.data);
	// 	// 			}
	// 	// 			setErrMsg(error?.response?.data?.message || errorMsg);
	// 	// 		});
	// 	// } catch (err) {
	// 	// 	setErrMsg('Failed');
	// 	// }
	// };

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	return (
		<>
			<Flex
				// jc='space-between'
				ai='center'
				// jc768='center'
				// ai768='center'
				// ff768='column'
				height='100%'>
				{largeScreen &&
					<LoginWrapper bg={bg} bg1={bg1} bg2={bg1}>
					</LoginWrapper>
				}

				{/* <Flex
					jc='right'
					ai='center'
					jc768='center'
					ai768='center'
					ff768='column'
					height='100%'> */}
				<Box style={{
					...styles.box, // Spread all existing styles
					maxWidth: !largeScreen ? "90vw" : "20vw", // Conditionally override the width
				}}>					{/* <Flex jc='center' mb='2rem' className='custom_logo'> */}
					{/* <img src={logo} alt='ZUE USA' /> */}
					<span style={{ width: "100%", textAlign: "center" }}>
						<img src={Logo} width="100%" />
						{/* </Flex> */}
						<MHeading align='center' fs='3rem' mb='3rem' mt="1em">
							Log in
						</MHeading>
						<Form onSubmit={handleSubmit}>
							{errMsg && (
								<Alert
									severity='error'
									sx={{
										fontSize: '1.4rem',
										padding: '0.5rem 1rem',
										width: '100%',
										marginBottom: '2.5em',
										fontWeight: '600',
										backgroundColor: `#fdeded !important`,
									}}>
									<span className='font-face-M'>{errMsg}</span>
								</Alert>
							)}
							<MarginHandler width='100%'>
								<TextField
									id='email'
									label='Email or ID'
									variant='filled'
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
									fullWidth
									style={{
										fontSize: '1.4rem',
										width: '100%',
									}}
									sx={{
										'& .MuiInputBase-input': {
											fontWeight: '600 !important',
											fontFamily: primaryFont,
											padding: '2.8rem 1.5rem 1rem',
										},
									}}
									className='font-face-R'
									error={errMsg?.includes('User')}
								/>
							</MarginHandler>

							<MarginHandler margin='2.5rem 0'>
								<FormControl sx={{ width: '100%' }} variant='filled'>
									<InputLabel htmlFor='password'>Password *</InputLabel>
									<FilledInput
										id='password'
										className='font-face-R'
										type={showPassword ? 'text' : 'password'}
										value={pwd}
										onChange={(e) => setPwd(e.target.value)}
										sx={{
											'& .MuiInputBase-input': {
												fontWeight: '600 !important',
												fontFamily: primaryFont,

												padding: '2.8rem 1.5rem 1rem',
												height: '2rem',
											},
										}}
										endAdornment={
											<InputAdornment position='end'>
												<IconButton
													aria-label='toggle password visibility'
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge='end'>
													{showPassword ? (
														<VisibilityOff />
													) : (
														<Visibility />
													)}
												</IconButton>
											</InputAdornment>
										}
									/>
								</FormControl>
							</MarginHandler>

							{/* <div>
								<ForgotPassword display2='none'>
								<Link to='/forget-password'>Forgotten Password?</Link>
								</ForgotPassword>
								</div> */}

							<MarginHandler mt='2rem'>
								<Button
									color='primary'
									variant='contained'
									fullWidth
									type='submit'
									disabled={disabledBtn}
									style={{
										backgroundColor: colorSecondary,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '1rem 3rem',
										color: colorWhite,
										borderRadius: '0.5rem',
									}}
									className='font-face-R'>
									{isLoading ? <CircularProgress sx={{ margin: "auto" }} color="success" /> :
										"Log in"
									}
								</Button>
							</MarginHandler>
						</Form>

					</span>
					{/* <ForgotPassword display1='none' display2='block' margin='1rem 0'>
							<Link to='/forget-password'>Forgotten Password?</Link>
						</ForgotPassword> */}
				</Box>
				{/* </Flex> */}
			</Flex>
		</>
	);
}

export default Login;
